import graphql__518b03f5a35a410adce3 from "./__generated__/ContributionsListWithoutNavigation_participativeModule.graphql.js";import { Suspense } from "react";
import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import ContributionsList, {
  ContributionsList_participativeModule
} from "./ContributionsList";
import { ResourcesListProvider } from "../../ResourcesList/resourcesList";
import ResourcesListUrlSearchSync from "../../ResourcesList/ResourcesListUrlSearchSync";
import { useFormatMessage } from "../../Intl/Context";
import { getContributionsAnchorId } from "../../Utils/anchorIds";
import AnchorTarget from "../../Utils/AnchorTarget";
import ContributionsListFilters from "./ContributionsListFilters";
import Icon from "../../Utils/Icon";
import { BoxSpinner } from "../../Utils/Spinner";
import ModalOutlet from "../../Routing/ModalOutlet";

const ContributionsListWithoutNavigation = props => {
  const participativeModule = useFragment(
    ContributionsListWithoutNavigation_participativeModule,
    props.participativeModule
  );

  const t = useFormatMessage();
  const listTitle = t(intlMessages.listTitle);
  const contributionsAnchorId = getContributionsAnchorId(participativeModule.slug);

  return (
    <ResourcesListProvider>
      <ResourcesListUrlSearchSync />
      <div className="container participative-module-container">
        <div className="contributions-list">
          <AnchorTarget id={contributionsAnchorId} />

          <div className="box margin-bottom-xs">
            <div className="contributions-list-title height-lg padding-y-md padding-x-sm text-title-section with-icon">
              <Icon className="text-primary icon-debate" />
              <h2 className="with-icon-text text-subtitle-page font-weight-bold">
                {listTitle}
              </h2>
            </div>
          </div>

          <ContributionsListFilters
            participativeModule={participativeModule}
            refetchFragment={ContributionsList_participativeModule}
          />

          <Suspense fallback={<BoxSpinner />}>
            <ContributionsList participativeModule={participativeModule} />
          </Suspense>
        </div>
      </div>

      <ModalOutlet />
    </ResourcesListProvider>
  );
};

const ContributionsListWithoutNavigation_participativeModule = graphql__518b03f5a35a410adce3;

export default ContributionsListWithoutNavigation;

const intlMessages = defineMessages({
  listTitle: {
    id: "participativeModule.contributionsList.listTitle",
    defaultMessage: "Les contributions"
  }
});
